/*
 *
 * GroupsInfoPopup
 *
 * @version 1.0.0
 * @author Marco Alessandroni
 * @since 09-May-2025
 */

import React from 'react'
import PropTypes from 'prop-types'
import MerchantModal from '@nexidigital/merchantmodal'
import formattedMessage from './languageModule'
import './GroupsInfoPopup.scss'

const GroupsInfoPopup = ({ onClose, availableGroups = [] }) => {
  // Define the mapping between group codes and their display info
  const groupInfoMap = {
    NEXI: {
      title: formattedMessage.nexiGroupTitle,
      description: formattedMessage.nexiGroupDescription
    },
    'NEXI DIRECT': {
      title: formattedMessage.nexiDirectGroupTitle,
      description: formattedMessage.nexiDirectGroupDescription
    },
    'INTESA SANPAOLO': {
      title: formattedMessage.intesaGroupTitle,
      description: formattedMessage.intesaGroupDescription
    },
    OTHER: {
      title: formattedMessage.otherGroupTitle,
      description: formattedMessage.otherGroupDescription
    }
  }

  // Normalize incoming group codes (API may return NEXI_DIRECT etc.)
  // and filter to show only the groups we have info for.
  const groupsToShow = availableGroups
    .map(g => ({ raw: g, key: (g || '').replace(/_/g, ' ') }))
    .filter(item => groupInfoMap[item.key])

  return (
    <MerchantModal
      title={formattedMessage.whatAreGroups}
      topBarTitle=' '
      onClose={onClose}
      ariaModalTitle={formattedMessage.infoOnGroups}
      ariaModalDescription={formattedMessage.descriptionOfCategories}
      primaryAction={onClose}
      subtitle=''
      iconName='info'
      withoutButton
    >
      <div className='groupsInfoContent'>
        <div className='groupsInfoContainer'>
          <div className='groupsInfoText'>
            <p>{formattedMessage.selectOnlyOneGroup}</p>
            <p>{formattedMessage.descriptionInfo}</p>
          </div>
          {groupsToShow.map(({ raw, key: groupCode }) => {
            const groupInfo = groupInfoMap[groupCode]
            return (
              <div key={raw} className='groupSection'>
                <span className='groupTitle'>{groupInfo.title}</span>
                <p>{groupInfo.description}</p>
              </div>
            )
          })}
        </div>
      </div>
    </MerchantModal>
  )
}

GroupsInfoPopup.propTypes = {
  // Add here some propTypes
  // and set a minimal description i.e.
  /** Description of prop "onClose". */
  onClose: PropTypes.func.isRequired,
  /** Array of available group codes to display information for. */
  availableGroups: PropTypes.arrayOf(PropTypes.string)
}

GroupsInfoPopup.defaultProps = {
  // Add here some default propTypes values
}

export default GroupsInfoPopup
